export const GET_REQUESTED_POSTS = 'GET_REQUESTED_POSTS'
export const ERROR = 'ERROR'
export const SORTED_VALUES = 'SORTED_VALUES'
export const FILTERED_DATA = 'FILTERED_DATA'
export const GET_MY_HOME = 'GET_MY_HOME'
export const CREATE_OWNER_REQUEST = 'CREATE_OWNER_REQUEST'
export const GET_VERIFIED_POSTS = 'GET_VERIFIED_POSTS'